import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

// directives/arabic-number.directive.ts
@Directive({
  selector: '[arabicNumber]',
  standalone: false,
})
export class ArabicNumberDirective {
  @Output() ngModelChange: EventEmitter<string> = new EventEmitter();

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const converted = convertArabicToWestern(event.target.value);
    this.ngModelChange.emit(converted);
    if (event.inputType === 'insertText')
      this.el.nativeElement.value = converted;

    return false;
  }
}
export function convertArabicToWestern(input: string): string {
  const persianNums = '۰۱۲۳۴۵۶۷۸۹';
  return input
    .split('')
    .map((char) => {
      const index = persianNums.indexOf(char);
      return index !== -1 ? index.toString() : char;
    })
    .join('');
}
